// // todo: check and set final urls to privacy policy page (when translations are available)

const docLang = document.documentElement.lang;
const lang = docLang.length > 2 ? docLang.substring(0, 2) : docLang;
const labels = {
  agree: {
    de: 'Auswahl bestätigen',
  },
  agreeAll: {
    de: 'Alle auswählen',
  },
  cookieTitle: {
    de: 'Ihre Cookie-Einstellungen',
    en: 'Your cookie settings',
    pl: 'Ustawienia plików cookie',
  },
  cookieText: {
    de: 'Um unsere Websites in Sachen Nutzerfreundlichkeit, Effektivität und Sicherheit für Sie zu optimieren, verwenden wir Cookies. Das sind kleine Textdateien, die auf Ihrem Datenendgerät abgelegt und in Ihrem Browser gespeichert werden.<br/> Darunter sind Cookies, die technisch für den Betrieb unserer Websites notwendig sind, sowie Cookies zur anonymen Webanalyse oder für erweiterte Funktionen und Services. Weitere Informationen dazu finden Sie in unserer <a class="styled-link" href="/datenschutz">Datenschutzerklärung</a>.<br/> Sie entscheiden, für welche Kategorien Sie dem Einsatz von Cookies zustimmen möchten und für welche nicht. Bitte berücksichtigen Sie, dass Ihnen je nach Auswahl ggf. nicht mehr alle Funktionen unserer Websites zur Verfügung stehen.',
  },
};

export const cookieBannerTemplate = (
  showOnRender,
  cookieTypes
) => `<section class="cookiebanner ${
  !showOnRender ? 'is-hidden' : ''
}" aria-modal="true" aria-labelledby="cookiebanner_label" role="dialog" tabindex="0">
    <div class="cookiebanner__inner">
        <div class="cookie-container">
            <header class="cookiebanner__header">
                <h1 class="cookiebanner__heading" id="cookiebanner_label" tabindex="0">${
                  labels.cookieTitle[lang]
                }</h1>
                <p>${labels.cookieText[lang]}</p>
            </header>

            <div class="cookie-section">
                <ul class="cookie-tab-list" role="tablist">
                  ${cookieTypes
                    .map(
                      (cookieType, index) =>
                        `<li class="cookie-tab-list-item">
                          <div class="cookie-tab-list-head">
                            <button
                                id="tab-${index}"
                                class="cookie-tab-heading"
                                aria-controls="tabpanel-${index}"
                                aria-selected="false"
                                role="tab"
                                >
                                <span>${cookieType.name[lang]}</span>
                            </button>
                            <label for="cookie-${index}" class="cookie-checkbox">
                                <input type="checkbox" id="cookie-${index}" class="sr-only" ${
                          cookieType.type === 'required' &&
                          'checked readonly disabled'
                        } ${cookieType.isChecked ? 'checked' : ''}>
                                <span class="sr-only">${
                                  cookieType.name[lang]
                                }</span>
                                <span class="toggler" aria-hidden="true"></span>
                            </label>
                          </div>
                          <div class="cookie-tab-panel" id="tabpanel-${index}" aria-labelledby="cookie-${index}" aria-hidden="true" role="tabpanel">
                          ${cookieType.text[lang]}
                          </div>
                      </li>`
                    )
                    .join('')}
                </ul>
            </div>

            <div class="action-wrapper">
                <button class="close-cookiebanner close-cookiebanner--inverted styled-button" data-confirm="all">
                  <span>${labels.agreeAll[lang]}</span>
                </button>
                <button class="close-cookiebanner close-cookiebanner--inverted styled-button" data-confirm="select">
                  <span>${labels.agree[lang]}</span>
                </button>
            </div>
        </div>
    </div>
</section>`;
